import InductionManagement from './InductionManagement';
export default InductionManagement